import debounce from '@/utils/debounce'
import targetsService from '@/api/targetsService'
import stringCompare from '@/utils/stringCompare'
import { TARGET_OPTIONS } from '@/utils/adminOptions'
/**
 *  TargetForm script file
**/

const DEBOUNCE_TIME = 500

export default {
  name: 'TargetForm',
  mixins: [],
  components: {},
  props: {},
  data () {
    return {
      target: {
        name: undefined,
        gender_ages: [],
        interests: [],
        type: TARGET_OPTIONS[1].value
      },
      interestsOptions: [],
      ageGenders: [],
      targetOptions: TARGET_OPTIONS
    }
  },
  async mounted () {
    this.$emit('selectTab', { id: 'targets' })
    if (this.$route.params.targetid) {
      this.target = await targetsService.getTarget({ id: this.$route.params.targetid })
    }

    this._interestsSearch = debounce(this.interestsSearch, DEBOUNCE_TIME)

    this.interestsSearch()
    this.getAgeGender()
  },
  computed: {
    formValid () {
      const isThirdPartyValid = this.target.name && this.target.interests && this.target.gender_ages && (this.target.gender_ages.length || this.target.interests.length)
      const isFirstPartyValid = this.target.name && this.target.identifier

      return this.isThirdParty ? isThirdPartyValid : isFirstPartyValid
    },
    isThirdParty () {
      return this.target.type === TARGET_OPTIONS[1].value
    },
    isEdit () {
      return this.target.id
    }
  },
  methods: {
    closeModal () {
      this.$router.push('/administration')
    },
    interestIsSelected ({ value }) { return this.target.interests.some(({ value: v }) => value === v) },
    slowInterestsSearch (query) {
      this.interestsOptions = this.interestsOptionsOriginal.filter(i => {
        const regexStr = new RegExp(`.*(${query}).*`, 'gi')
        return regexStr.test(i.label)
      })
    },
    interestsSearch () {
      targetsService.getTargetsInterests().then(data => {
        data = data.sort((a, b) => stringCompare(a.value, b.value))
          .map(d => {
            d.root = d.value.indexOf('-') === -1
            return d
          })
        this.interestsOptions = data
        this.interestsOptionsOriginal = data
      })
    },
    async getAgeGender () {
      let ranges, genders, options
      await Promise.all([targetsService.getAgeRange(), targetsService.getGenders()]).then(([_ranges, _genders]) => {
        ranges = _ranges
        genders = _genders
      })
      options = genders.map(g => {
        return this.target.gender_ages ? ranges.map(r => {
          const isSelected = this.target.gender_ages.find(item => item.age_range === r.value && item.gender === g.value)
          return { age_range: r.value, gender: g.value, active: isSelected }
        }) : []
      })
      this.ageGenders = options
    },
    onSelectInterest ({ value }) {
      this.$refs.interestSelector.close()
      const index = this.target.interests.findIndex(i => i.value === value)
      const interest = this.interestsOptions.find(io => io.value === value)
      if (index === -1) {
        this.target.interests.push(interest)
      } else {
        this.target.interests.splice(index, 1)
      }
    },
    onSelectAgeGender (genderIndex, ageIndex) {
      this.ageGenders[genderIndex][ageIndex].active = !this.ageGenders[genderIndex][ageIndex].active
      this.target.gender_ages = this.ageGenders.map(g => g.filter(a => a.active)).flat()
    },
    updateScrollbar () {
      window.setTimeout(() => {
        if (this.$refs.scrollbar) this.$refs.scrollbar.update()
      }, 250)
    },
    async save () {
      if (!this.formValid) { return }

      const body = {
        name: this.target.name,
        type: this.target.type
      }

      // Third party
      if (this.target.type === TARGET_OPTIONS[1].value) {
        body.interests = this.target.interests.map(i => i.value)
        body.gender_age_data = this.target.gender_ages.map(a => ({ age_range: a.age_range, gender: a.gender }))
      } else { // First party
        body.identifier = this.target.identifier
      }

      try {
        let target
        let action = 'add'
        if (this.target.id) {
          body.id = this.target.id
          action = 'update'
          await targetsService.editTarget(body)
          target = this.target
        } else {
          target = await targetsService.createTarget(body)
        }
        this.$router.push({ path: `/administration` })
        this.$emit(action, { type: 'targets', value: target })
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error('[target-form.js] Error saving new target', err)
      }
    }
  }
}
